import { render } from "./FormEditView.vue?vue&type=template&id=24c89d4d"
import script from "./FormEditView.vue?vue&type=script&lang=js"
export * from "./FormEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__